import { useQuery, type Query } from '@tanstack/react-query'
import { PaytrieAPI } from '@paytrie/client'

import { usePageStateStore } from '@/reducers'

type Requirements = PaytrieAPI.UserRequirements

type Options = {
  refetchInterval?:
    | number
    | false
    | ((query: Query<Requirements>) => number | false)
}

const STALE_TIME_MS = 5 * 60 * 1000

export const useOnboardingRequirements = (
  enabled: boolean,
  options: Options = {}
) => {
  const authToken = usePageStateStore.use.authToken()
  return useQuery({
    queryKey: ['v2', 'users', 'me', 'requirements', authToken],
    queryFn: async () => {
      const res = await PaytrieAPI.getCurrentUserRequirements()
      if (res.status !== 200) {
        throw new Error(
          `Failed to load user requirements (status ${res.status})`
        )
      }
      return res.data.data
    },
    enabled,
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),
    staleTime: STALE_TIME_MS,
    refetchInterval: options.refetchInterval ?? false,
  })
}
